import { combineReducers } from "redux";
import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import { GUEST_ACCESS_TYPES } from "@loanbossinc/component-library";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
  , makeIsLoadingReducer
  , subKeySaga
  , fillDictionary
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const PEOPLE_GET_DEAL_BY_ID = generateDefaultActions("PEOPLE_GET_DEAL_BY_ID");
export const peopleDealGetById = payload => makePayload(PEOPLE_GET_DEAL_BY_ID.value, payload);
function* peopleDealGetByIdSaga(payload) {
  const url = `/deals/${payload.dealId}`;
  yield requestSaga(PEOPLE_GET_DEAL_BY_ID, url, "GET");
}

export const PEOPLE_UPDATE_DEAL = generateDefaultActions("PEOPLE_UPDATE_DEAL");
export const peopleUpdateDeal = payload => makePayload(PEOPLE_UPDATE_DEAL.value, payload);
function* peopleUpdateDealSaga(payload) {
  const { deal } = payload;
  const url = `/deals/${deal.id}/people`;
  const callback = handleCallback(payload);
  yield requestSaga(PEOPLE_UPDATE_DEAL, url, "PUT", { deal });
  yield callback();
}

export const PEOPLE_GET_BROKERS = generateDefaultActions("PEOPLE_GET_BROKERS");
export const peopleGetBrokers = payload => makePayload(PEOPLE_GET_BROKERS.value, payload);
function* peopleGetBrokersSaga() {
  const url = "/getBrokers";
  yield requestSaga(PEOPLE_GET_BROKERS, url);
}

export const PEOPLE_GET_CONTACTS_BY_COMPANY = generateDefaultActions("PEOPLE_GET_CONTACTS_BY_COMPANY");
export const peopleGetContactsByCompany = payload => makePayload(PEOPLE_GET_CONTACTS_BY_COMPANY.value, payload);
function* peopleGetContactsByCompanySaga(payload) {
  const { companyId } = payload;
  const url = `/company/${companyId}/contacts`;
  yield requestSaga(PEOPLE_GET_CONTACTS_BY_COMPANY, url);
}

export const PEOPLE_GET_CONTACTS_BY_DEAL = generateDefaultActions("PEOPLE_GET_CONTACTS_BY_DEAL");
export const peopleGetContactsByDeal = payload => makePayload(PEOPLE_GET_CONTACTS_BY_DEAL.value, payload);
function* peopleGetContactsByDealSaga(payload) {
  const { dealId } = payload;
  const url = `/dealCompanyContacts/${dealId}`;
  yield requestSaga(PEOPLE_GET_CONTACTS_BY_DEAL, url);
}

export const PEOPLE_GET_GUESTS_BY_DEAL = generateDefaultActions("PEOPLE_GET_GUESTS_BY_DEAL");
export const peopleGetGuestsByDeal = payload => makePayload(PEOPLE_GET_GUESTS_BY_DEAL.value, payload);
function* peopleGetGuestsByDealSaga(payload) {
  const { dealId, accessTypeId } = payload;
  const url = `/guest/deal?dealId=${dealId}&accessTypeId=${accessTypeId}`;
  yield requestSaga(PEOPLE_GET_GUESTS_BY_DEAL, url);
}

export const PEOPLE_DELETE_GUEST_BY_DEAL = generateDefaultActions("PEOPLE_DELETE_GUEST_BY_DEAL");
export const peopleDeleteGuestsByDeal = payload => makePayload(PEOPLE_DELETE_GUEST_BY_DEAL.value, payload);
function* peopleDeleteGuestsByDealSaga(payload) {
  const { id, dealId, accessTypeId } = payload;
  const callback = handleCallback(payload);
  const url = `/guest/deal?id=${id}&dealId=${dealId}&accessTypeId=${accessTypeId}`;
  yield requestSaga(PEOPLE_DELETE_GUEST_BY_DEAL, url, "DELETE");
  yield callback();
}

// PEOPLE_GET_GUEST_BY_DEALID
export const PEOPLE_GET_GUEST_BY_DEALID = generateDefaultActions("PEOPLE_GET_GUEST_BY_DEALID");
export const getGuestsByDealId = payload => makePayload(PEOPLE_GET_GUEST_BY_DEALID.value, payload);
function* getGuestsByDealIdSaga(payload) {
  const { dealId, accessTypeId } = payload;
  const requestSaga = subKeySaga(payload.dealId);
  yield requestSaga(PEOPLE_GET_GUEST_BY_DEALID, `/guest/deal?dealId=${dealId}&accessTypeId=${accessTypeId}`);
}

// PEOPLE_ADD_GUESTS_TO_DEAL
export const PEOPLE_ADD_GUESTS_TO_DEAL = generateDefaultActions("PEOPLE_ADD_GUESTS_TO_DEAL");
export const addGuestsToDeal = payload => makePayload(PEOPLE_ADD_GUESTS_TO_DEAL.value, payload);
function* addGuestsToDealSaga(payload) {
  const callback = handleCallback(payload);
  const requestSaga = subKeySaga(payload.dealId);
  yield requestSaga(PEOPLE_ADD_GUESTS_TO_DEAL, "/guest/deal", "POST", payload);
  yield callback();
}
// PEOPLE_INVITE_GUEST_TO_TARGET_EMAIL
export const PEOPLE_INVITE_GUEST_TO_TARGET_EMAIL = generateDefaultActions("PEOPLE_INVITE_GUEST_TO_TARGET_EMAIL");
export const inviteGuestToTargetEmail = payload => makePayload(PEOPLE_INVITE_GUEST_TO_TARGET_EMAIL.value, payload);
function* inviteGuestToTargetEmailSaga(payload) {
  const url = "/guestInvitationEmail";
  yield requestSaga(PEOPLE_INVITE_GUEST_TO_TARGET_EMAIL, url, "POST", payload);
}

// REDUCER
const initialState = {
  deal: null,
  brokers: [],
  companyContacts: [],
  dealContacts: [],
  dealGuests: []
};

function peopleModuleReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case PEOPLE_GET_DEAL_BY_ID.success:
      return defaultReturn(state, payload.deal, "deal");

    case PEOPLE_UPDATE_DEAL.success:
      return defaultReturn(state, payload);

    case PEOPLE_GET_BROKERS.success:
      return defaultReturn(state, payload, "brokers");

    case PEOPLE_GET_CONTACTS_BY_COMPANY.success:
      return defaultReturn(state, payload.data, "companyContacts");

    case PEOPLE_GET_CONTACTS_BY_DEAL.success:
      return defaultReturn(state, payload, "dealContacts");

    case PEOPLE_GET_GUESTS_BY_DEAL.success:
    case PEOPLE_DELETE_GUEST_BY_DEAL.success:
      return defaultReturn(state, payload.response, "dealGuests");

    case PEOPLE_GET_DEAL_BY_ID.error:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case PEOPLE_GET_GUEST_BY_DEALID.success:
    case PEOPLE_ADD_GUESTS_TO_DEAL.success:
      return fillDictionary(state, payload.response, "dealguests", subKey);

    default:
      return state;
  }
}

export default combineReducers({
  peopleModuleReducer
});

// SAGA
export function* peopleModuleSaga() {
  yield takeLatest(PEOPLE_GET_DEAL_BY_ID.value, peopleDealGetByIdSaga);
  yield takeLatest(PEOPLE_UPDATE_DEAL.value, peopleUpdateDealSaga);
  yield takeLatest(PEOPLE_DELETE_GUEST_BY_DEAL.value, peopleDeleteGuestsByDealSaga);
  yield takeLatest(PEOPLE_GET_BROKERS.value, peopleGetBrokersSaga);
  yield takeLatest(PEOPLE_GET_CONTACTS_BY_COMPANY.value, peopleGetContactsByCompanySaga);
  yield takeLatest(PEOPLE_GET_CONTACTS_BY_DEAL.value, peopleGetContactsByDealSaga);
  yield takeLatest(PEOPLE_GET_GUESTS_BY_DEAL.value, peopleGetGuestsByDealSaga);

  yield takeLatest(PEOPLE_GET_GUEST_BY_DEALID.value, getGuestsByDealIdSaga);
  yield takeLatest(PEOPLE_ADD_GUESTS_TO_DEAL.value, addGuestsToDealSaga);
  yield takeLatest(PEOPLE_INVITE_GUEST_TO_TARGET_EMAIL.value, inviteGuestToTargetEmailSaga);
}
